var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-wrapper"},[_c('b-breadcrumb',{staticClass:"custom-bread",attrs:{"items":_vm.breadcrumbs}}),_c('p',{staticClass:"time-logger"},[_vm._v(_vm._s(_vm.$t('globalTrans.welcomeTo'))+", "+_vm._s(_vm.authUser ? (_vm.currentLocale === 'bn' ? _vm.authUser.name_bn : _vm.authUser.name) : ''))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }